"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalEventNames = void 0;
var AddBasketOfferEvent = _interopRequireWildcard(require("@ori-events/add-basket-offer"));
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var BambuserLiveShoppingEvent = _interopRequireWildcard(require("@ori-events/bambuser-live-shopping"));
var BannerClickEvent = _interopRequireWildcard(require("@ori-events/banner-click"));
var BannerDataLoadedEvent = _interopRequireWildcard(require("@ori-events/banner-data-loaded"));
var ClearBasketEvent = _interopRequireWildcard(require("@ori-events/clear-basket"));
var ContextDataEvent = _interopRequireWildcard(require("@ori-events/context-data"));
var DownloadFile = _interopRequireWildcard(require("@ori-events/download-file"));
var ExpressCheckoutButtonClickEvent = _interopRequireWildcard(require("@ori-events/express-checkout-button-click"));
var FollowUsItemClickEvent = _interopRequireWildcard(require("@ori-events/follow-us-item-click"));
var LinkClickEvent = _interopRequireWildcard(require("@ori-events/link-click"));
var NewsletterSubscribeEvent = _interopRequireWildcard(require("@ori-events/newsletter-subscribe"));
var OlapicClickedEvent = _interopRequireWildcard(require("@ori-events/olapic-popup-product-clicked"));
var OrderPlacedEvent = _interopRequireWildcard(require("@ori-events/order-placed"));
var PersonalProductListEvent = _interopRequireWildcard(require("@ori-events/personal-product-list"));
var ProductClickEvent = _interopRequireWildcard(require("@ori-events/product-click"));
var ProductDataLoadedEvent = _interopRequireWildcard(require("@ori-events/product-data-loaded"));
var RemoveBasketItemEvent = _interopRequireWildcard(require("@ori-events/remove-basket-item"));
var SearchSuggestionClickEvent = _interopRequireWildcard(require("@ori-events/search-suggestion-click"));
var ShareItemClickEvent = _interopRequireWildcard(require("@ori-events/share-item-click"));
var UpdateBasketItemEvent = _interopRequireWildcard(require("@ori-events/update-basket-item"));
var UpdateOfferItemEvent = _interopRequireWildcard(require("@ori-events/update-offer-item"));
var UserActionEvent = _interopRequireWildcard(require("@ori-events/user-action"));
var UserRegisteredEvent = _interopRequireWildcard(require("@ori-events/user-registered"));
var UserUpgradeRequested = _interopRequireWildcard(require("@ori-events/user-upgrade-requested"));
var VideoPlayEvent = _interopRequireWildcard(require("@ori-events/video-play"));
var VirtualPageEvent = _interopRequireWildcard(require("@ori-events/virtual-page"));
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
/**
 * @deprecated Remove these event as they get replaced by the generic integration event.
 **/
const globalEventNames = exports.globalEventNames = [AddBasketOfferEvent.Name, AddToBasketEvent.Name, BambuserLiveShoppingEvent.Name, BannerClickEvent.Name, BannerDataLoadedEvent.Name, ClearBasketEvent.Name, ContextDataEvent.Name, DownloadFile.Name, ExpressCheckoutButtonClickEvent.Name, FollowUsItemClickEvent.Name, LinkClickEvent.Name, NewsletterSubscribeEvent.Name, OlapicClickedEvent.Name, OrderPlacedEvent.Name, PersonalProductListEvent.Name, ProductClickEvent.Name, ProductDataLoadedEvent.Name, RemoveBasketItemEvent.Name, SearchSuggestionClickEvent.Name, ShareItemClickEvent.Name, UpdateBasketItemEvent.Name, UpdateOfferItemEvent.Name, UserActionEvent.Name, UserRegisteredEvent.Name, VideoPlayEvent.Name, VirtualPageEvent.Name, UserUpgradeRequested.Name];